import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/style/reset.css';
import '@/assets/style/base.scss';

import installElementPlus from '@/plugins/element'


const app = createApp(App);
app.use(router).use(installElementPlus).mount("#app")



